import { FunctionComponent, ReactNode } from 'react';
import { Languages } from '../top-menu/top-menu';

export type Props = {
  language: Languages;
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties | undefined;
};

const B: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {window.location.href.indexOf('/' + props.language + '/') !== -1 && (
        <b className={props.className} style={props.style}>
          {props.children}
        </b>
      )}
    </>
  );
};

export default B;
